import { useTranslation } from 'react-i18next';
import { ReactComponent as Attention } from '../icons/attention.svg';
import './Comment.scss';

interface Props {
  comment: string;
  className?: string;
}

export default function Comment({ comment, className = '' }: Props) {
  const { t } = useTranslation();
  return (
    <div className={`Comment px-3 pt-2 pb-3 ${className}`}>
      <div className='d-flex aling-items-center mb-2'>
        <Attention className='me-2' />
        <div className='fw-800'>{t('Please note')}</div>
      </div>
      <div className='multiline'>{comment}</div>
    </div>
  );
}
